import { type ReactNode } from 'react';
import { Badge } from '@/components/ui/badge';
import type { Payment } from '../types';
import { formatPeriod } from '../utils/payment-formatters';
import { CopyWalletButton } from './copy-wallet-button';

function MinBadge({ meets }: { meets: boolean }): ReactNode {
  return meets ? (
    <Badge variant="success">+$100</Badge>
  ) : (
    <Badge variant="warning">&lt;$100</Badge>
  );
}

function CardBadges({ p }: { p: Payment }): ReactNode {
  return (
    <div className="flex flex-col items-end gap-1">
      <MinBadge meets={p.meets_minimum} />
      {p.usdc_wallet ? (
        <CopyWalletButton wallet={p.usdc_wallet} />
      ) : (
        <Badge variant="default">Sin wallet</Badge>
      )}
    </div>
  );
}

export function PaymentCardHeader({
  payment: p,
}: {
  payment: Payment;
}): ReactNode {
  return (
    <div className="flex items-start justify-between gap-sm">
      <div>
        <p className="text-sm font-medium text-text-primary">
          @{p.collector_name}
        </p>
        <p className="mt-0.5 text-[10px] text-text-tertiary">
          {formatPeriod(p.period_start, p.period_end)}
        </p>
      </div>
      <CardBadges p={p} />
    </div>
  );
}
